export const CanonicalRedirect = ({destination}: {destination: string}) => <div className="boot-screen" role="status" data-testid="canonical-redirect">
  <div className="canonical-redirect-content">
    <h2>Opening your workspace</h2>
    <p data-testid="canonical-redirect-message">Continuing at your workspace’s primary address…</p>
    <a href={destination} data-testid="canonical-redirect-link">Continue to workspace</a>
  </div>
</div>;